(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arm-homepage"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.arm-site').forEach(site=>{
  const rental=site.querySelector('#Rental');
  const equipment=site.querySelector('#ARMEquipment');
  const dialog=site.querySelector('.arm-dialog');
  const openRental=()=>{rental.open=true;dialog.close();rental.scrollIntoView({behavior:'smooth',block:'start'});};
  site.querySelectorAll('[data-rental]').forEach(link=>link.addEventListener('click',()=>{rental.open=true;}));
  site.querySelectorAll('[data-product]').forEach(button=>button.addEventListener('click',()=>{
    site.querySelector('.arm-product-title').textContent=button.dataset.product;
    dialog.dataset.product=button.dataset.product;
    dialog.showModal();
  }));
  site.querySelector('.arm-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  site.querySelector('.arm-product-enquiry').addEventListener('click',()=>{
    equipment.value=dialog.dataset.product;
    openRental();
    equipment.focus({preventScroll:true});
  });
  const params=new URLSearchParams(location.search);
  if(params.has('rental_product')){const selected=params.get('rental_product').replace(/-/g,' ');equipment.value=selected;rental.open=true;}
  if(location.hash==='#Rental'||location.search.includes('contact_posted')||site.querySelector('.arm-success')||site.querySelector('.errors'))rental.open=true;
  const start=site.querySelector('[name="contact[Rental start]"]');
  const end=site.querySelector('[name="contact[Rental end]"]');
  start.addEventListener('change',()=>{end.min=start.value;if(end.value&&end.value<start.value)end.value=start.value;});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arm-rentals"] && !Shopify.designMode) return;
  try {
    
  function initARMRentals() {
    document.querySelectorAll('.arm-rental-page').forEach(root => {
      if (root.dataset.rentalReady) return;
      root.dataset.rentalReady = 'true';
      const message = root.querySelector('textarea[name="contact[body]"]');
      const start = root.querySelector('[data-arm-rental-start]');
      const end = root.querySelector('[data-arm-rental-end]');
      function syncDates() {
        if (!start || !end) return;
        end.min = start.value;
        end.setCustomValidity(end.value && start.value && end.value < start.value ? end.dataset.dateError : '');
      }
      if (start && end) {
        start.addEventListener('change', syncDates);
        end.addEventListener('change', syncDates);
      }
      root.querySelectorAll('[data-arm-hire-product]').forEach(link => link.addEventListener('click', () => {
        if (!message) return;
        const title = link.dataset.armHireProduct;
        if (!message.value.includes(title)) message.value += (message.value.trim() ? '\n' : '') + title;
        message.focus({ preventScroll: true });
      }));
    });
  }
  initARMRentals();
  document.addEventListener('shopify:section:load', initARMRentals);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arm-shop-equipment"] && !Shopify.designMode) return;
  try {
    
function initARMCuratedCatalogue(){(function(){const r=document.querySelector('[data-arm-curated-catalogue]');if(!r||r.dataset.curatedReady)return;r.dataset.curatedReady='true';const buttons=r.querySelectorAll('aside [data-brand]'),cards=r.querySelectorAll('.product'),input=r.querySelector('#catalogSearch'),empty=r.querySelector('#catalogEmpty');let brand='all';function update(){let n=0;const q=input.value.toLowerCase().trim();cards.forEach(c=>{const show=(brand==='all'||c.dataset.brand===brand)&&(!q||c.dataset.search.includes(q));c.hidden=!show;if(show)n++});empty.hidden=n>0}buttons.forEach(b=>b.addEventListener('click',()=>{brand=b.dataset.brand;buttons.forEach(x=>{x.classList.toggle('active',x===b);x.setAttribute('aria-pressed',String(x===b))});update()}));input.addEventListener('input',update);update()})();}
initARMCuratedCatalogue();document.addEventListener('shopify:section:load',initARMCuratedCatalogue);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
